import { DetailedCarOrderValues } from '@/services/leads/typings';
import { submitDetailedCarOrder } from '@/services/leads/leads-service';
import { attachCaptchaToken } from '@/utils/captcha';

import {
  convertFormValues,
  convertValuesByExtraOptions,
} from './common.helpers';
import { ExtraOptionsType } from './common.types';

export async function submitOrderForm(
  values: DetailedCarOrderValues & { captchaToken?: string },
  extraOptions: ExtraOptionsType
) {
  const { captchaToken, ...formValues } = values;
  const preValues = convertValuesByExtraOptions(formValues, extraOptions);
  const body = convertFormValues(preValues);

  if (captchaToken) {
    return submitDetailedCarOrder(
      attachCaptchaToken(body, captchaToken) as DetailedCarOrderValues
    );
  }

  return submitDetailedCarOrder(body);
}
